import {
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent
} from '@mui/material'
import { useCallback } from 'react'

interface Zone {
  id: number
  name: string
}

interface ZoneSelectProps {
  label: string
  name: string
  value: string
  onChange: (e: SelectChangeEvent<unknown>, _child: React.ReactNode) => void
  error?: string
  zones: Zone[]
  required: boolean
}

export default function ZoneSelect({
  zones,
  label,
  name,
  value,
  onChange,
  error,
  required
}: Readonly<ZoneSelectProps>) {
  const getZoneNameById = useCallback(
    (id: number) => {
      const zone = zones.find(zone => zone.id === id)
      return zone ? zone.name : '?'
    },
    [zones]
  )

  return (
    <FormControl sx={{ minWidth: 200 }} required={required}>
      <InputLabel>{label}</InputLabel>
      <Select
        name={name}
        required={required}
        label={label}
        value={value}
        onChange={onChange}
        renderValue={selected => <Chip color="primary" label={getZoneNameById(Number(selected))} />}
        error={!!error}
      >
        {zones.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={!!error}>{error}</FormHelperText>
    </FormControl>
  )
}
